<template>
  <div class="bm-sign-up-list" >
    <div v-if="!otherTeams.length && checkCount <= 0" >
      <div class="title" >暂无球队报名！</div>
      <p>快去召集球队吧</p>
    </div>
    <div v-if="!otherTeams.length && checkCount> 0" >
      <div class="title" >已无报名球队需要审核！</div>
      <router-link :to="'/team?matchId=' + matchId" class="link-style" >返回球队管理首页</router-link>
    </div>
    <div v-if="otherTeams.length" >
      <div class="title">
        报名球队待审核
        <span>{{ refuseList.length }}/<i>{{ teamLength }}</i></span>
      </div>
      <div class="player" @click="routerTeamEdit(player.teamId, player.auditStatus, player.createUser)" v-for="player in otherTeams" :key="player.id" >
        <div>
          <img :src="formatterImgSrc(player.teamBadge)" >
        </div>
        <div>
          <p>{{ player.teamName }}</p>
          <span :class="{active: player.auditStatus === -1}" >{{ teamStatus(player.auditStatus) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Toast } from 'vant'
import { ImageFormat } from '@/utils/'
import { getBMMatchTeams } from '@/api/team'
Vue.use(Toast)
export default {
  name: 'SignUpList',
  data () {
    return {
      query: '',
      chinckIn: false,
      otherTeams: [],
      teamLength: null,
      refuseList: null,
      checkCount: null
    }
  },
  created() {
    this.query = this.$route.query
    this.matchId = this.query.matchId
    if (!this.matchId) {
      Toast.loading({
        mask: true,
        message: '参数错误',
        duration: 0
      })
      return
    }
    this.getBMMatchTeams()
  },
  computed: {
    formatterImgSrc() {
      return function(src) {
        return ImageFormat.imageView(src, 104, 104)
      }
    },
    teamStatus() {
      return function (status) {
        if (status === -1) {
          return '已拒绝'
        } else {
          return '待审核'
        }
      }
    }
  },
  methods: {
    routerTeamEdit: function (teamId = null, auditStatus = null, createUser = {}) {
      this.$router.push({
        path: '/sign-up/edit',
        query: {
          teamId: teamId,
          matchId: this.matchId,
          auditStatus: auditStatus,
          createUser: JSON.stringify(createUser)
        }
      })
    },
    getBMMatchTeams() {
      getBMMatchTeams({ matchId: this.matchId }).then((response) => {
        let data = response.data
        this.checkCount = data.checkCount
        this.teamLength = data.otherTeams.length
        this.otherTeams = data.otherTeams.filter((item) => {
          if (item.auditStatus === -1 || item.auditStatus === 1 || item.auditStatus === 0) {
            return item
          }
        })
        this.refuseList = data.otherTeams.filter((item) => {
          return item.auditStatus !== -1
        })
      })
    }
  }
}
</script>
<style lang="stylus" >
.bm-sign-up-list
  background-color white
  .title
    font-size: 30px;
    font-weight: 400;
    color: rgba(0,0,0,1);
    padding: 10px 15px;
  span
    letter-spacing 2px
    text-align left
    float right
    i
      font-size: 18px
      font-style: normal
  .title+p
    font-size:16px;
    font-weight:300;
    color:rgba(0,0,0,1);
    padding: 0 15px
    margin-top 0
  .player
    display flex
    padding 15px
    div:first-child
      width 52px
      height 52px
      margin-right: 10px
      img
        width 52px
        height 52px
    div:last-child
      display flex
      flex-direction column
      justify-content: space-between;
      width: calc(100% - 62px)
      p
        margin: 0;
        font-size:14px;
        font-weight:400;
        color:rgba(0,0,0,1);
      span
        font-size: 12px;
        font-weight: 400;
        color: #32A377;
      .active
        color: #EC4E4E
        background-color white !important
  .link-style
    font-size: 16px;
    font-family: PingFangSC-Light;
    font-weight: 300;
    color: rgba(0,0,0,1);
    padding: 0 15px;
</style>



// WEBPACK FOOTER //
// src/pages/team/sign-up/list.vue